module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "school-data"
  }, [_c('div', {
    staticClass: "school-data__header"
  }, [_c('div', {
    staticClass: "school-data__header__left"
  }, [_c('h1', [_vm._v("Vikardækning")]), _vm._v(" "), _c('changeSchoolYear', {
    staticClass: "marg-1-right",
    attrs: {
      "white-theme": true
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "school-data__header__right"
  }, [(!_vm.isDatesPristine) ? _c('p', {
    staticClass: "d-link",
    on: {
      "click": _vm.resetDates
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.task_overview.reset')))]) : _vm._e(), _vm._v(" "), _c('Datepickerrange', {
    attrs: {
      "startdate": _vm.startDate,
      "enddate": _vm.endDate
    },
    on: {
      "startchanged": _vm.setStartDate,
      "endchanged": _vm.setEndDate
    }
  })], 1)]), _vm._v(" "), (_vm.isLoading) ? _c('div', {
    staticClass: "loader-container"
  }, [_c('Loader'), _vm._v(" "), _c('h4', [_vm._v("Snup en kop kaffe, det kan tage et par minutter")])], 1) : [_c('p', {
    staticClass: "text-explainer"
  }, [_vm._v("\n      Berørte timer er lektioner, hvor en lærer har registreret fravær, eller hvor der er sat en vikar på.\n      De fordeles på: dækket af vikar, medlærer til stede uden vikar, aflyst, ude af huset og ikke dækket.\n      \"% med vikarnoter\" er andelen af lektioner med fravær, hvor der er skrevet vikarnoter.\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "school-data__toolbar"
  }, [_c('Tabs', {
    attrs: {
      "tabs": _vm.viewTabs,
      "selected": _vm.viewMode
    },
    on: {
      "select": function($event) {
        _vm.viewMode = $event
      }
    }
  }), _vm._v(" "), _c('Tabs', {
    attrs: {
      "tabs": _vm.sortTabs,
      "selected": _vm.sortMode
    },
    on: {
      "select": function($event) {
        _vm.sortMode = $event
      }
    }
  })], 1), _vm._v(" "), (_vm.viewMode === 'grades') ? _c('SchoolDataCoverageTable', {
    attrs: {
      "title": "Årgang",
      "rows": _vm.gradeRows
    }
  }) : _vm._e(), _vm._v(" "), (_vm.viewMode === 'klasses') ? _c('SchoolDataCoverageTable', {
    attrs: {
      "title": "Klasse",
      "rows": _vm.klassRows
    }
  }) : _vm._e(), _vm._v(" "), (_vm.viewMode === 'subjects') ? _c('SchoolDataCoverageTable', {
    attrs: {
      "title": "Fag",
      "rows": _vm.subjectRows
    }
  }) : _vm._e()]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-23fd2210!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SchoolData/SchoolDataCoverage.vue
// module id = 1806
// module chunks = 1